/**
 * URL de la API: REACT_APP_API (.env) → runtime-config.js (solo si no hay env) → fallback.
 */

const PRODUCTION_API = 'https://hospedapp-api-production.up.railway.app';
const DEVELOPMENT_API = 'http://localhost:3800';

function getRuntimeConfig() {
  if (typeof window !== 'undefined' && window.__HOSPEDAPP_CLIENTS_CONFIG__) {
    return window.__HOSPEDAPP_CLIENTS_CONFIG__;
  }
  return {};
}

function trimTrailingSlash(value) {
  return typeof value === 'string' ? value.replace(/\/$/, '') : '';
}

export function getApiUrl() {
  const fromEnv = trimTrailingSlash(process.env.REACT_APP_API);
  if (fromEnv) {
    return fromEnv;
  }

  const runtime = getRuntimeConfig();
  const fromRuntime = trimTrailingSlash(runtime.API_URL);
  if (fromRuntime) {
    return fromRuntime;
  }

  if (process.env.NODE_ENV === 'production') {
    return PRODUCTION_API;
  }

  return DEVELOPMENT_API;
}

export function isApiUrlConfigured() {
  return Boolean(getApiUrl());
}
